import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'index',
        component: ()=> import('../components/HelloWorld')
    },
    {
        path: '/chargeRecord',
        name: 'record',
        component: ()=> import('../components/Record')
    },

]


const router = new VueRouter({
    routes
});

export default router